import request from "@/utils/request";

//代祭扫信息录入

export function replaceSacrifice_add(data) {
  return request({
    url: "/sys/replaceSacrifice/add",
    method: "post",
    data,
  });
}